import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const COOKIE_CONSENT_VERSION = "v2";
const COOKIE_CONSENT_KEY = `cookie_consent_${COOKIE_CONSENT_VERSION}`;
const VALID_CONSENTS = new Set(["accepted", "rejected"]);

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const current = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (VALID_CONSENTS.has(current)) {
        setShow(false);
        return;
      }

      // Show banner if value is missing or malformed.
      setShow(true);
    } catch (_) {
      // If storage is blocked/unavailable, still show consent UI.
      setShow(true);
    }
  }, []);

  if (!show) return null;

  const set = (v) => {
    try {
      localStorage.setItem(COOKIE_CONSENT_KEY, v);
    } catch (_) {
      // no-op: hide banner in-session even if persistence fails
    }
    setShow(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 border-t border-foreground bg-background p-4 shadow-2xl" data-testid="cookie-banner">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm flex-1">
          We use essential cookies to keep you signed in and analytics cookies to improve the product.
          See our <Link to="/legal" className="underline">Legal Documents and Policies</Link>.</p>
        <div className="flex gap-2">
          <Button variant="outline" className="rounded-none" onClick={() => set("rejected")} data-testid="cookie-reject">Reject</Button>
          <Button className="rounded-none btn-brutalist" onClick={() => set("accepted")} data-testid="cookie-accept">Accept</Button>
        </div>
      </div>
    </div>
  );
}
